import {syncHistoryWithStore, routerMiddleware} from 'react-router-redux';
import {createStore, compose, applyMiddleware} from 'redux';
import {viasConnect} from 'vias';
import RavenMiddleware from 'redux-raven-middleware';

import config from 'oo-config';

import reducers from './states/reducers';

import {
  Product,
} from 'sp-components/models';

export default function createAppStore(history, initialState = {}, browserWindow = {}) {
  const middlewares = [
    routerMiddleware(history),
  ];
  if (config.env !== 'development') {
    middlewares.push(RavenMiddleware(config.raven.dns));
  }
  const mainMiddlewares = applyMiddleware(...middlewares);

  const finalCreateStore = compose(
    mainMiddlewares,
    browserWindow.devToolsExtension ? browserWindow.devToolsExtension() : noop => noop
  )(createStore);

  const store = finalCreateStore(reducers, initialState);

  viasConnect(
    store,
    Product,
  );
  syncHistoryWithStore(history, store);

  return store;
}



// WEBPACK FOOTER //
// ./app/store.js